import { cn } from '@/lib/utils';
import GlassFilter from './GlassFilter';

/**
 * Selective liquid glass surface — navigation & premium controls only.
 */
export default function ResqlyLiquidSurface({
  children,
  className,
  filterId = 'resqly-glass-filter',
  pressed = false,
  ...props
}) {
  return (
    <div
      className={cn(
        'relative isolate overflow-hidden',
        pressed && 'scale-[0.98]',
        'transition-transform duration-200 ease-out',
        className,
      )}
      {...props}
    >
      <div
        className="absolute inset-0 rounded-[inherit] bg-white/55 dark:bg-slate-900/45"
        style={{ backdropFilter: `url("#${filterId}") blur(18px) saturate(1.65)` }}
      />
      <div
        className="absolute inset-0 rounded-[inherit] border border-white/55 shadow-[inset_0_1px_0_rgba(255,255,255,0.65),0_14px_40px_rgba(30,64,175,0.1),0_4px_12px_rgba(15,23,42,0.06)]"
      />
      <div className="absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-white/80 to-transparent" />
      <div className="relative z-10">{children}</div>
      <GlassFilter id={filterId} />
    </div>
  );
}
